import axios from "axios";

// Always use SAME-ORIGIN (relative) API calls. Emergent deployments proxy
// /api/* to the backend on the same host, so:
//   - preview:   https://<preview-domain>/api/* ✓
//   - production https://<your-domain>/api/* ✓
// Using same-origin avoids third-party cookie blocking in modern browsers
// (which is what breaks auth on custom domains like calcutta.mahakalitribunal.com).
// If you ever need to override (e.g. running frontend locally against a
// remote backend), set REACT_APP_BACKEND_URL.
const BACKEND_URL =
  (typeof window !== "undefined" &&
    process.env.REACT_APP_BACKEND_URL &&
    // Use baked URL only when it matches current origin OR in dev
    (window.location.origin === process.env.REACT_APP_BACKEND_URL ||
     window.location.hostname === "localhost"))
    ? process.env.REACT_APP_BACKEND_URL
    : "";

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
